import { Translate } from "@redotech/redo-i18n";
import { TemplateType } from "@redotech/redo-marketing-templates-common/email-builder";
import { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { Step, StepId } from "@redotech/redo-return-ui/flows/step";

export const RETURN_REASON_TITLE = CONDITION_NAMES[Condition.RETURN_REASON];
export const CLAIM_REASON_TITLE = "Claim reason";
export const WARRANTY_REASON_TITLE = "Warranty reason";

export function reasonTitleForFlowType(flowType: FlowType): string {
  // tslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- TODO: grandfather FIXME
  switch (flowType) {
    case FlowType.CLAIM:
    case FlowType.FINALIZE_CLAIM:
      return CLAIM_REASON_TITLE;
    case FlowType.WARRANTY:
    case FlowType.WARRANTY_REGISTRATION:
    case FlowType.FINALIZE_WARRANTY:
      return WARRANTY_REASON_TITLE;
    default:
      return RETURN_REASON_TITLE;
  }
}

export function getTemplateTypeLabel(
  t: Translate,
  templateType: TemplateType,
): string {
  switch (templateType) {
    case TemplateType.TRANSACTIONAL:
      return t("Transactional", { context: "message template type" });
    case TemplateType.MARKETING:
      return t("Marketing", { context: "message template type" });
    case TemplateType.RECOVER:
      return t("Recover", { context: "message template type" });
    case TemplateType.DEFAULT:
      return t("Default", { context: "message template type" });
  }
}

export function getAllPathsToStep(
  startStepId: StepId,
  targetStepId: StepId,
  allSteps: Map<StepId, Step>,
): StepId[][] {
  const queue: { path: StepId[]; current: StepId }[] = [
    { path: [startStepId], current: startStepId },
  ];
  const result: StepId[][] = [];
  while (queue.length > 0) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { path, current } = queue.shift()!;
    if (current === targetStepId) {
      result.push(path);
      continue;
    }
    const step = allSteps.get(current);
    if (!step) {
      continue;
    }
    // Get downstream step ids
    const downstreams = step
      .downstream()
      .map((ds) => ds.id)
      .filter(Boolean) as StepId[];
    for (const nextId of downstreams) {
      if (path.includes(nextId)) {
        continue;
      } // avoid cycles
      queue.push({ path: [...path, nextId], current: nextId });
    }
  }
  return result;
}

export function isBonusAdjustment(adjustmentString: string): boolean {
  return parseFloat(adjustmentString) >= 0;
}
